/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ParameterOptions } from './ParameterOptions';

export type Parameter = {
    name: string;
    key: string;
    description: string;
    tooltip: string;
    min: number | null;
    max: number | null;
    defaultValue: any;
    type: Parameter.type;
    options: Array<ParameterOptions>;
}

export namespace Parameter {

    export enum type {
        NUMBER = 'NUMBER',
        STRING = 'STRING',
        RANGE = 'RANGE',
        SELECT = 'SELECT',
        COLOR = 'COLOR',
    }


}
